// Chat Header Component
// Displays the chat header with title, language indicator, and close button

import { Button } from '@/components/ui/button';
import { MessageSquare, X, Globe } from 'lucide-react';

const ChatHeader = ({ 
  detectedLanguage, 
  detectedLanguageName, 
  showLanguageSelector, 
  onChangeLanguage, 
  onClose 
}) => {
  return (
    <div className="bg-slate-900 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center">
          <MessageSquare className="w-4 h-4 text-white" />
        </div>
        <div>
          <h3 className="text-white font-semibold text-sm">IntakePal</h3>
          <p className="text-slate-400 text-xs">
            {detectedLanguage !== 'en' && !showLanguageSelector ? (
              <button 
                onClick={onChangeLanguage}
                className="flex items-center gap-1 hover:text-teal-400 transition-colors"
                title="Change language"
                data-testid="change-language-btn"
              >
                <Globe className="w-3 h-3" />
                {detectedLanguageName}
                <span className="text-[10px]">✎</span>
              </button>
            ) : !showLanguageSelector ? (
              <button 
                onClick={onChangeLanguage}
                className="hover:text-teal-400 transition-colors"
                title="Change language"
                data-testid="change-language-btn"
              >
                Online now
              </button>
            ) : (
              'Online now'
            )}
          </p>
        </div>
      </div>
      <Button 
        variant="ghost" 
        size="icon" 
        className="text-slate-400 hover:text-white hover:bg-white/10"
        onClick={onClose}
        data-testid="close-chat-btn"
      >
        <X className="w-5 h-5" />
      </Button>
    </div>
  );
};

export default ChatHeader;
